import React, { useState, useEffect, useRef } from "react"
import {
  Form,
  Spin,
  Input,
  Row,
  Col,
  Card,
  Divider,
  Typography,
  Descriptions,
} from "antd"
import * as Http from "utils/http.helper"
import Breadcrumbs from "components/Common/Breadcrumb"
import ImageComponent from "components/image"
import SVGFromURL from "components/svg2comp"
import errorImage from "assets/images/error-img.png"
import toastr from "toastr"
import "toastr/build/toastr.min.css"
// Black t-shirt
import teeFrontBlack from "assets/images/transparent/TEE/TEE-B-FRONT.png"
import teeBackBlack from "assets/images/transparent/TEE/TEE-B-BACK.png"
import teeLeftBlack from "assets/images/transparent/TEE/TEE-B-LEFT.png"
import teeRightBlack from "assets/images/transparent/TEE/TEE-B-RIGHT.png"
// White t-shirt
import teeFrontWhite from "assets/images/transparent/TEE/TEE-W-FRONT.png"
import teeBackWhite from "assets/images/transparent/TEE/TEE-W-BACK.png"
import teeLeftWhite from "assets/images/transparent/TEE/TEE-W-LEFT.png"
import teeRightWhite from "assets/images/transparent/TEE/TEE-W-RIGHT.png"
// Black Onesie
import onesieFrontBlack from "assets/images/transparent/ONESIE/ONESIE-B-FRONT.png"
import onesieBackBlack from "assets/images/transparent/ONESIE/ONESIE-B-BACK.png"
// White Onesie
import onesieFrontwhite from "assets/images/transparent/ONESIE/ONESIE-W-FRONT.png"
import onesieBackwhite from "assets/images/transparent/ONESIE/ONESIE-W-BACK.png"
// Black Sweatshirt
import sweatshirtFrontBlack from "assets/images/transparent/SWEATSHIRT/SWEATSHIRT-B-FRONT.png"
import sweatshirtBackBlack from "assets/images/transparent/SWEATSHIRT/SWEATSHIRT-B-BACK.png"
import sweatshirtLeftBlack from "assets/images/transparent/SWEATSHIRT/SWEATSHIRT-B-LEFT.png"
import sweatshirtRightBlack from "assets/images/transparent/SWEATSHIRT/SWEATSHIRT-B-RIGHT.png"
// White Sweatshirt
import sweatshirtFrontWhite from "assets/images/transparent/SWEATSHIRT/SWEATSHIRT-W-FRONT.png"
import sweatshirtBackWhite from "assets/images/transparent/SWEATSHIRT/SWEATSHIRT-W-BACK.png"
import sweatshirtLeftWhite from "assets/images/transparent/SWEATSHIRT/SWEATSHIRT-W-LEFT.png"
import sweatshirtRightWhite from "assets/images/transparent/SWEATSHIRT/SWEATSHIRT-W-RIGHT.png"
// Black Hoodie
import hoodieFrontBlack from "assets/images/transparent/HOODIE/HOODIE-B-FRONT.png"
import hoodieBackBlack from "assets/images/transparent/HOODIE/HOODIE-B-BACK.png"
import hoodieLeftBlack from "assets/images/transparent/HOODIE/HOODIE-B-LEFT.png"
import hoodieRightBlack from "assets/images/transparent/HOODIE/HOODIE-B-RIGHT.png"
// White Hoodie
import hoodieFrontWhite from "assets/images/transparent/HOODIE/HOODIE-W-FRONT.png"
import hoodieBackWhite from "assets/images/transparent/HOODIE/HOODIE-W-BACK.png"
import hoodieLeftWhite from "assets/images/transparent/HOODIE/HOODIE-W-LEFT.png"
import hoodieRightWhite from "assets/images/transparent/HOODIE/HOODIE-W-RIGHT.png"

//Bamboo Wall Decor
import bambooWallDecor from "assets/images/transparent/PRINT/BAMBOO_WALL_DECOR/BAMBOO_WALL_DECOR.png"
//Banner Stand
import bannerStand from "assets/images/transparent/PRINT/BANNER_STAND/BANNER_STAND.png"
//Car visor
import carVisor from "assets/images/transparent/PRINT/CAR_VISOR/CAR_VISOR.png"
// golf Towel
import golfTowel from "assets/images/transparent/PRINT/GOLF_TOWEL/GOLF_TOWEL.png"
// hanging canvas
import hangingCanvas from "assets/images/transparent/PRINT/HANGING_CANVAS/HANGING_CANVAS.png"

// Banner
import banner from "assets/images/transparent/PRINT/BANNER/BANNER.png"
// cake
import cakeTopper from "assets/images/transparent/PRINT/CAKE_TOPPER/CAKE_TOPPER.png"
//canvas
import canvas from "assets/images/transparent/PRINT/CANVAS/CANVAS.png"
//doormat
import doormat from "assets/images/transparent/PRINT/DOORMAT/DOORMAT.png"
//label
import labelImage from "assets/images/transparent/PRINT/LABEL/LABEL.png"
//mug
import mugBack from "assets/images/transparent/PRINT/MUG/MUG_BACK.png"
import mugFront from "assets/images/transparent/PRINT/MUG/MUG_FRONT.png"
//name flag
import nameFlag from "assets/images/transparent/PRINT/NAME_FLAG/NAME_FLAG.png"
//table runner
import tableRunner from "assets/images/transparent/PRINT/TABLE_RUNNER/TABLE_RUNNER.png"
//photo frame
import photoFrameWhite from "assets/images/transparent/PRINT/PHOTO_FRAME/PHOTO_FRAME_WHITE.png"
//wall hangings
import wallHangings from "assets/images/transparent/PRINT/WALL_HANGINGS/WALL_HANGINGS.png"

//ornament
import ornamentHeart from "assets/images/transparent/PRINT/ORNAMENT/ORNAMENT_HEART.png"
import ornamentRound from "assets/images/transparent/PRINT/ORNAMENT/ORNAMENT_ROUND.png"

//puzzle
import puzzleHeart from "assets/images/transparent/PRINT/PUZZLE/PUZZLE_HEART.png"
import puzzleRectangle from "assets/images/transparent/PRINT/PUZZLE/PUZZLE_RECTANGLE.png"
//sticker
import ketchupSticker from "assets/images/transparent/PRINT/KETCHUP_STICKER/KETCHUP_STICKER.png"
import nutellaSticker from "assets/images/transparent/PRINT/NUTELLA_STICKER/NUTELLA_STICKER.png"
//trinket
import trinketHeart from "assets/images/transparent/PRINT/TRINKET/TRINKET_HEART.png"
import trinketRound from "assets/images/transparent/PRINT/TRINKET/TRINKET_ROUND.png"
import trinketSquare from "assets/images/transparent/PRINT/TRINKET/TRINKET_SQUARE.png"

//yard sign
import yardSignVertical from "assets/images/transparent/PRINT/YARD_SIGN/YARD_SIGN_VERTICAL.png"
import yardSignHorizontal from "assets/images/transparent/PRINT/YARD_SIGN/YARD_SIGN_HORIZONTAL.png"

import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons"
import { getEncodedS3Url } from "utils/encodedS3url"

const { Paragraph } = Typography

const allPositions = [
  { name: "Front Center", code: "front_center" },
  { name: "Spine", code: "spine" },
  { name: "Front Vertical on the Right", code: "front_vertical_on_the_right" },
  { name: "Front Left Lower Corner", code: "front_left_lower_corner" },
  { name: "Front Bottom Center", code: "front_bottom_center" },
  { name: "Inside Center", code: "inside_center" },
  { name: "Inside Upper Side", code: "inside_upper_side" },
  { name: "Inside Left Lower Corner", code: "inside_left_lower_corner" },
  { name: "Inside Left Side", code: "inside_left_side" },
  { name: "Inside Right Side", code: "inside_right_side" },
  { name: "Back Center", code: "back_center" },
  { name: "Back Right Lower Corner", code: "back_right_lower_corner" },
  { name: "Back Bottom Center", code: "back_bottom_center" },
  { name: "Stones", code: "stones" },
  { name: "Tools", code: "tools" },
  { name: "Guitar Pick", code: "guitar_pick" },
  { name: "Front Right Lower Corner", code: "front_right_lower_corner" },
]

const optionGroup = [
  {
    value: "front",
    label: "Front View",
  },
  {
    value: "left_front",
    label: "Left and Upper Front View",
  },
  {
    value: "rigth_front",
    label: "Right and Upper Front View",
  },
  {
    value: "left",
    label: "Left Side View",
  },
  {
    value: "right",
    label: "Right Side View",
  },
  {
    value: "back",
    label: "Back View",
  },
  {
    value: "inside_right_sleeve",
    label: "Inside Right Sleeve",
  },
  {
    value: "inside_left_sleeve",
    label: "Inside Left Sleeve",
  },
  {
    value: "outside_right_sleeve",
    label: "Outside Right Sleeve",
  },
  {
    value: "outside_left_sleeve",
    label: "Outside Left Sleeve",
  },
  {
    value: "heart",
    label: "Heart View",
  },
  {
    value: "round",
    label: "Round View",
  },
  {
    value: "rectangle",
    label: "Rectangle View",
  },
  {
    value: "ketchup",
    label: "Ketchup View",
  },
  {
    value: "nutella",
    label: "Nutella View",
  },
  {
    value: "square",
    label: "Square View",
  },
  {
    value: "vertical",
    label: "Vertical View",
  },
  {
    value: "horizontal",
    label: "Horizontal View",
  },
]

const MultipleShipment = () => {
  document.title = "Multiple Shipment Page | EASY JET CONNECT"
  const [form] = Form.useForm()
  const inputRef = useRef(null)
  const [loading, setLoading] = useState(false)
  const [orderNo, setOrderNo] = useState("")
  const [data, setData] = useState(null)
  const [boxLoading, setBoxLoading] = useState(false)
  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  const handleInputChange = e => {
    if (e.key === "Enter" && e.target.value.trim().length > 0) {
      fetchOrder(e.target.value.trim())
    }
  }

  const fetchOrder = orderId => {
    setLoading(true)
    setOrderNo(orderId)
    form.resetFields()
    const orderStatus =
      JSON.parse(localStorage.getItem("authUserV0"))?.actions?.length > 0
        ? JSON.parse(localStorage.getItem("authUserV0"))?.actions?.length > 0 &&
          JSON.parse(localStorage.getItem("authUserV0"))?.actions[0] ===
            "Completed"
          ? 50
          : 60
        : 0
    setBoxLoading(true)
    Http.get(
      `api/orders/GetMultipleOrderImagesByOrder?orderId=${orderId}&status=${orderStatus}`
    )
      .then(response => {
        if (response.success) {
          setData(response.data)
        } else {
          toastr.error(
            `${orderId} numaralı order henüz print etmek için hazır olmayabilir (Has Image=false) ve ya order numaranız hatalı olabilir. Kontrol ediniz!`
          )
          setData(null)
        }
        setLoading(false)
        setBoxLoading(false)
      })
      .catch(error => {
        toastr.error(error?.response?.data?.Message || "Sunucu hatası!")
        setLoading(false)
        setBoxLoading(false)
        setData(null)
      })
  }

  const renderEngraving = () =>
    data?.engraving?.orderImages?.length > 0 && (
      <>
        <Divider orientation="left">Engraving Products</Divider>
        <Row gutter={[16, 16]}>
          {data.engraving.orderImages.map((item, idx) => (
            <Col lg={item.length > 1 ? 12 : 24} key={item.sku + "_" + idx}>
              <Card className="mb-3" bordered hoverable>
                <Row gutter={[5, 5]}>
                  <Col span={24}>
                    <Descriptions
                      bordered
                      layout="vertical"
                      column={{
                        xs: 2,
                        sm: 4,
                        md: 4,
                        lg: 4,
                        xl: 4,
                        xxl: 4,
                      }}
                    >
                      <Descriptions.Item label="Sku">
                        <span
                          style={{
                            fontWeight: "bold",
                          }}
                        >
                          {item.sku}
                        </span>
                      </Descriptions.Item>
                      <Descriptions.Item label="Color">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            columnGap: 20,
                          }}
                        >
                          <div
                            style={{
                              backgroundColor:
                                item.positions[0].templateColorHexCode,
                              height: 30,
                              width: 30,
                              borderRadius: "100%",
                              boxShadow: "#0000002e 0px 0px 10px 2px",
                            }}
                          ></div>
                          <div
                            className="whiteSpace-normal"
                            style={{
                              color: item.positions[0].templateColorHexCode,
                              fontWeight: "bold",
                            }}
                          >
                            {item.positions[0].templateColorHexCode}
                          </div>
                        </div>
                      </Descriptions.Item>
                      <Descriptions.Item label="Product Name">
                        {item.productName}
                      </Descriptions.Item>
                      <Descriptions.Item label="Quantity">
                        {item.quantity}
                      </Descriptions.Item>
                      <Descriptions.Item label="Is UvPrint">
                        {item.isUvprint ? (
                          <CheckCircleOutlined
                            style={{ color: "green", fontSize: 20 }}
                          />
                        ) : (
                          <CloseCircleOutlined
                            style={{ color: "red", fontSize: 20 }}
                          />
                        )}
                      </Descriptions.Item>
                      <Descriptions.Item label="Variation">
                        <Paragraph copyable> {item?.variation}</Paragraph>
                      </Descriptions.Item>
                      {item?.note && (
                        <Descriptions.Item label="Note">
                          <Paragraph copyable={item?.note ? true : false}>
                            {item?.note ? item.note : "--"}
                          </Paragraph>
                        </Descriptions.Item>
                      )}
                    </Descriptions>
                  </Col>

                  {item.positions.map((x, i) => {
                    let position = allPositions.find(
                      a => a.code === x.positionCode
                    )
                    return (
                      <Col
                        className="mt-2 mb-2"
                        span={item.length > 1 ? 12 : 8}
                        key={position + "_" + x.positionCode + "_" + i}
                      >
                        <Descriptions
                          bordered
                          layout="vertical"
                          className="mb-2"
                          title={
                            <div
                              style={{
                                fontWeight: "700",
                              }}
                            >
                              * {position?.name}
                            </div>
                          }
                          column={{
                            xs: 2,
                            sm: 2,
                            md: 2,
                            lg: 2,
                            xl: 2,
                            xxl: 2,
                          }}
                        >
                          <Descriptions.Item
                            label="Template"
                            style={{ textAlign: "center" }}
                          >
                            <style>
                              {`.${item.sku} g g polyline, g g line{ stroke: blue!important }
                           .${item.sku} rect, .${item.sku} path { fill: ${x.templateColorHexCode}!important }
                            `}
                            </style>

                            <SVGFromURL
                              className={item.sku}
                              url={x.templateImageUrl}
                              width={120}
                              height={120}
                            />
                          </Descriptions.Item>
                          <Descriptions.Item
                            label="Design"
                            style={{ textAlign: "center" }}
                          >
                            <ImageComponent
                              imageUrl={x.imgUrl}
                              width={120}
                              height={120}
                            />
                          </Descriptions.Item>
                        </Descriptions>
                      </Col>
                    )
                  })}
                </Row>
              </Card>
            </Col>
          ))}
        </Row>
      </>
    )

  const renderApparel = () =>
    data?.apparel?.length > 0 && (
      <>
        <Divider orientation="left">Apparel Products</Divider>
        <Row gutter={[16, 16]}>
          {data.apparel.map((item, idx) => {
            let labelName = optionGroup.find(
              x => x.value === item?.positionCode
            )
            const css = `
                  .img_${idx}{
                      ${
                        item?.colorHexCode === "#fff" ||
                        item?.colorHexCode === "#ffffff" ||
                        item?.colorHexCode === "#000" ||
                        item?.colorHexCode === "#000000"
                          ? "background-color:#e8e8e8ad"
                          : ""
                      }
                  }
                  `

            return (
              <Col xs={6} key={idx + "-col"}>
                <style>{css}</style>
                <Card
                  title={labelName?.label}
                  hoverable
                  id={item.positionCode}
                  key={idx + "-file"}
                  style={{
                    padding: "10px",
                    border: "1px solid #c5c5c58f",
                  }}
                >
                  <Spin spinning={boxLoading}>
                    {item.positionCode === "left" ? (
                      <div style={{ background: item.colorHexCode }}>
                        <ImageComponent
                          key={`tshirt_${idx}]`}
                          imageUrl={
                            item.colorHexCode === "#000000"
                              ? item.styleName === "Sweatshirt"
                                ? sweatshirtLeftWhite
                                : item.styleName === "Hoodie"
                                ? hoodieLeftWhite
                                : teeLeftWhite
                              : item.styleName === "Sweatshirt"
                              ? sweatshirtLeftBlack
                              : item.styleName === "Hoodie"
                              ? hoodieLeftBlack
                              : teeLeftBlack
                          }
                          width="100%"
                          height="100%"
                          preview={false}
                        />
                      </div>
                    ) : item.positionCode === "right" ? (
                      <div style={{ background: item.colorHexCode }}>
                        <ImageComponent
                          key={`tshirt_${idx}]`}
                          imageUrl={
                            item.colorHexCode === "#000000"
                              ? item.styleName === "Sweatshirt"
                                ? sweatshirtRightWhite
                                : item.styleName === "Hoodie"
                                ? hoodieRightWhite
                                : teeRightWhite
                              : item.styleName === "Sweatshirt"
                              ? sweatshirtRightBlack
                              : item.styleName === "Hoodie"
                              ? hoodieRightBlack
                              : teeRightBlack
                          }
                          width="100%"
                          height="100%"
                          preview={false}
                        />
                      </div>
                    ) : item.positionCode === "back" ? (
                      <div style={{ background: item.colorHexCode }}>
                        <ImageComponent
                          key={`tshirt_${idx}]`}
                          imageUrl={
                            item.colorHexCode === "#000000"
                              ? item.styleName === "Sweatshirt"
                                ? sweatshirtBackWhite
                                : item.styleName === "Hoodie"
                                ? hoodieBackWhite
                                : item.styleName === "Onesie"
                                ? onesieBackwhite
                                : teeBackWhite
                              : item.styleName === "Sweatshirt"
                              ? sweatshirtBackBlack
                              : item.styleName === "Hoodie"
                              ? hoodieBackBlack
                              : item.styleName === "Onesie"
                              ? onesieBackBlack
                              : teeBackBlack
                          }
                          width="100%"
                          height="100%"
                          preview={false}
                        />
                      </div>
                    ) : item.positionCode === "outside_right_sleeve" ||
                      item.positionCode === "outside_left_sleeve" ? (
                      <div style={{ background: item.colorHexCode }}>
                        <ImageComponent
                          key={`tshirt_${idx}]`}
                          imageUrl={
                            item.colorHexCode === "#000000"
                              ? sweatshirtBackWhite
                              : sweatshirtBackBlack
                          }
                          width="100%"
                          height="100%"
                          preview={false}
                        />
                      </div>
                    ) : item.positionCode === "inside_right_sleeve" ||
                      item.positionCode === "inside_left_sleeve" ? (
                      <div style={{ background: item.colorHexCode }}>
                        <ImageComponent
                          key={`tshirt_${idx}]`}
                          imageUrl={
                            item.colorHexCode === "#000000"
                              ? sweatshirtFrontWhite
                              : sweatshirtFrontBlack
                          }
                          width="100%"
                          height="100%"
                          preview={false}
                        />
                      </div>
                    ) : (
                      <div style={{ background: item.colorHexCode }}>
                        <ImageComponent
                          key={`tshirt_${idx}]`}
                          imageUrl={
                            item.colorHexCode === "#000000"
                              ? item.styleName === "Sweatshirt"
                                ? sweatshirtFrontWhite
                                : item.styleName === "Hoodie"
                                ? hoodieFrontWhite
                                : item.styleName === "Onesie"
                                ? onesieFrontwhite
                                : teeFrontWhite
                              : item.styleName === "Sweatshirt"
                              ? sweatshirtFrontBlack
                              : item.styleName === "Hoodie"
                              ? hoodieFrontBlack
                              : item.styleName === "Onesie"
                              ? onesieFrontBlack
                              : teeFrontBlack
                          }
                          width="100%"
                          height="100%"
                          preview={false}
                        />
                      </div>
                    )}

                    <div
                      className={
                        item.positionCode +
                        " " +
                        item.styleName.toLowerCase() +
                        " printer " +
                        `img_${idx}`
                      }
                      key={`div_${idx}]`}
                      style={{
                        backgroundImage: `url(${getEncodedS3Url(
                          item.imageUrl
                        )})`,
                        border: "red 1px dashed",
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "bottom",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    />

                    <Divider />
                    <Row gutter={[16, 16]}>
                      <Col lg={10}>
                        Style:{" "}
                        <span className="text-primary">{item?.styleName}</span>
                      </Col>
                      <Col lg={14}>
                        Sku: <span className="text-primary">{item?.sku}</span>
                      </Col>

                      <Col lg={10}>
                        Color:{" "}
                        <span className="text-primary">{item?.colorName}</span>
                      </Col>
                      <Col lg={7}>
                        Size:{" "}
                        <span className="text-primary">{item?.sizeName}</span>
                      </Col>

                      <Col lg={7}>
                        {" "}
                        Price:{" "}
                        <span
                          className="text-primary"
                          style={{ marginRight: 15 }}
                        >
                          ${item?.totalPrice}
                        </span>
                      </Col>
                    </Row>
                  </Spin>
                </Card>
              </Col>
            )
          })}
        </Row>
      </>
    )

  const renderPrint = () =>
    data?.print?.length > 0 && (
      <>
        <Divider orientation="left">Print Products</Divider>
        <Row gutter={[16, 16]}>
          {data.print.map((item, idx) => {
            let labelName = optionGroup.find(
              x => x.value === item?.positionCode
            )

            let imageUrl = null
            const label = item?.styleName

            switch (item?.positionCode) {
              case "front":
                imageUrl =
                  label === "Banner"
                    ? banner
                    : label === "Tent Banner"
                    ? banner
                    : label === "Cake Topper"
                    ? cakeTopper
                    : label === "Canvas"
                    ? canvas
                    : label === "Doormat"
                    ? doormat
                    : label === "Label"
                    ? labelImage
                    : label === "Frame"
                    ? photoFrameWhite
                    : label === "Wall Hangings"
                    ? wallHangings
                    : label === "Car Visor"
                    ? carVisor
                    : label === "Bamboo Wall Decor"
                    ? bambooWallDecor
                    : label === "Table Runner"
                    ? tableRunner
                    : label === "Ketchup Sticker"
                    ? ketchupSticker
                    : label === "Nutella Sticker"
                    ? nutellaSticker
                    : label === "Hanging Canvas"
                    ? hangingCanvas
                    : label === "Banner Stand"
                    ? bannerStand
                    : label === "Golf Towel"
                    ? golfTowel
                    : label === "Name Flag"
                    ? nameFlag
                    : label === "Mug"
                    ? mugFront
                    : doormat // Default image
                break
              case "heart":
                imageUrl =
                  label === "Ornament"
                    ? ornamentHeart
                    : label === "Puzzle"
                    ? puzzleHeart
                    : label === "Trinket Dish"
                    ? trinketHeart
                    : doormat // Default image
                break
              case "back":
                imageUrl = label === "Mug" ? mugBack : doormat // Default image
                break
              case "round":
                imageUrl =
                  label === "Ornament"
                    ? ornamentRound
                    : label === "Trinket Dish"
                    ? trinketRound
                    : doormat // Default image
                break
              case "rectangle":
                imageUrl = label === "Puzzle" ? puzzleRectangle : doormat // Default image
                break
              case "square":
                imageUrl = label === "Trinket Dish" ? trinketSquare : doormat // Default image
                break
              case "vertical":
                imageUrl = label === "Yard Sign" ? yardSignVertical : doormat // Default image
                break
              case "horizontal":
                imageUrl = label === "Yard Sign" ? yardSignHorizontal : doormat // Default image
                break
              default:
                imageUrl = doormat // Default image
            }
            const css = `
            .img_${item?.positionCode}{
            position:absolute;
            top:29%;
            left:29%;
            z-index:1;
            width:150px;
            height:150px;
              ${
                item?.colorHexCode === "#fff" ||
                item?.colorHexCode === "#ffffff" ||
                item?.colorHexCode === "#000" ||
                item?.colorHexCode === "#000000"
                  ? "background-color:#e8e8e8ad"
                  : ""
              }
            }
            `
            return (
              <Col xs={6} key={idx + "-col"}>
                <style>{css}</style>
                <Card
                  title={labelName?.label}
                  hoverable
                  id={item.positionCode}
                  key={idx + "-file"}
                  style={{
                    padding: "10px",
                    border: "1px solid #c5c5c58f",
                  }}
                >
                  <Spin spinning={boxLoading}>
                    <div style={{ background: item?.colorHexCode }}>
                      <ImageComponent
                        key={`tshirt_${idx}]`}
                        imageUrl={imageUrl}
                        width="100%"
                        height="100%"
                        preview={false}
                      />
                    </div>
                    <div
                      className={
                        item?.positionCode +
                        " " +
                        item?.styleName?.toLowerCase() +
                        " printer " +
                        `img_${item?.positionCode}`
                      }
                      key={`div_${idx}]`}
                      style={{
                        backgroundImage: `url(${getEncodedS3Url(
                          item?.imageUrl
                        )})`,
                        border: "red 1px dashed",
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "bottom",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    />

                    <Divider />
                    <Row gutter={[16, 16]}>
                      <Col lg={10}>
                        Style:{" "}
                        <span className="text-primary">{item?.styleName}</span>
                      </Col>
                      <Col lg={14}>
                        Sku: <span className="text-primary">{item?.sku}</span>
                      </Col>

                      <Col lg={10}>
                        Color:{" "}
                        <span className="text-primary">{item?.colorName}</span>
                      </Col>
                      <Col lg={7}>
                        Size:{" "}
                        <span className="text-primary">{item?.sizeName}</span>
                      </Col>

                      <Col lg={7}>
                        {" "}
                        Price:{" "}
                        <span
                          className="text-primary"
                          style={{ marginRight: 15 }}
                        >
                          ${item?.totalPrice}
                        </span>
                      </Col>
                    </Row>
                  </Spin>
                </Card>
              </Col>
            )
          })}
        </Row>
      </>
    )

  return (
    <div className="page-content">
      <Spin spinning={loading}>
        <Breadcrumbs title="Multiple Shipment" />
        <Card className="mt-2 mb-2">
          <Form form={form} layout="vertical">
            <Form.Item label="Order Number" name="barcode">
              <Input
                ref={inputRef}
                placeholder="Order numarası girin..."
                onPressEnter={handleInputChange}
              />
            </Form.Item>
          </Form>
          <div style={{ display: "flex", gap: "10px" }}>
            {orderNo && (
              <div style={{ fontWeight: "bold", marginTop: "10px" }}>
                Order No: {orderNo}
              </div>
            )}
            {data?.apparel?.length > 0 && (
              <div
                style={{
                  fontWeight: "bold",
                  marginTop: "10px",
                  color: "salmon",
                }}
              >
                Apparel Order :{" "}
                {new Set(data.apparel.map(item => item.orderId)).size}
              </div>
            )}

            {data?.engraving?.orderImages.length > 0 && (
              <div
                style={{
                  fontWeight: "bold",
                  marginTop: "10px",
                  color: "salmon",
                }}
              >
                Engraving Order : {data?.engraving?.orderImages.length}
              </div>
            )}
            {data?.print?.length > 0 && (
              <div
                style={{
                  fontWeight: "bold",
                  marginTop: "10px",
                  color: "salmon",
                }}
              >
                Print Order :{" "}
                {new Set(data.print.map(item => item.orderId)).size}
              </div>
            )}
          </div>
        </Card>

        {!loading && !data && (
          <div className="text-center">
            <img src={errorImage} alt="Error" style={{ width: "200px" }} />
            <h5>Lütfen geçerli bir Order numarası girin.</h5>
          </div>
        )}

        {data && (
          <>
            {renderEngraving()}
            {renderApparel()}
            {renderPrint()}
          </>
        )}
      </Spin>
    </div>
  )
}

export default MultipleShipment
